import dateBetween from '@/helpers/validator/rules/date_between'

export default (value, {from, to, inclusivity = '()', format = 'YYYY-MM-DD HH:mm:ss', units = 'milliseconds'}, validator, fieldName) => {
    return dateBetween(
        value,
        {
            from,
            to,
            inclusivity,
            format,
            units
        },
        validator,
        fieldName
    )
}
